// extracted by mini-css-extract-plugin
export default {"banner":"BillingPausedBanner_banner__9Tqqe"};